module.exports = __webpack_public_path__ + "img/treusuisse.834e7b5a.png";